// extracted by css-extract-rspack-plugin
export default {"banner":"InaccessibleAttachmentsBanner-module__banner__rn5qv"};